import { createFileRoute } from "@tanstack/react-router";
import { SDPPage } from "../../../pages/sdp-page";

export const Route = createFileRoute("/_auth/_project/$projectId/$subProjectId/sdp")({
  component: SDPPage,
});
